import styled from "@emotion/styled"

export const BlockItemStringStyles = styled.div`
    margin-bottom: 20px;
`